<template>
  <div>
    <ButtonBack class="mb_m"/>

    <show-number />

    <input-card-number />
    <input-suit />
    <input-name />
    <input-url />
    <input-description />
    <input-hint />
    <input-place />
    <input-radius />
    <search-location class="mt_m"/>

    <Pager class="mb_m"/>

    <slot></slot>

    <router-view />
  </div>
</template>

<script>
import ButtonBack from '@/components/ButtonBack'
import Pager from '@/components/Quiz/Pager'
import ShowNumber from '@/components/Quiz/ShowNumber'
import InputCardNumber from '@/components/Quiz/InputCardNumber'
import InputSuit from '@/components/Quiz/InputSuit'
import InputName from '@/components/Quiz/InputName'
import InputUrl from '@/components/Quiz/InputUrl'
import InputDescription from '@/components/Quiz/InputDescription'
import InputHint from '@/components/Quiz/InputHint'
import InputPlace from '@/components/Quiz/InputPlace'
import InputRadius from '@/components/Quiz/InputRadius'
import SearchLocation from '@/components/Quiz/SearchLocation'

export default {
  components: {
    ButtonBack,
    Pager,
    ShowNumber,
    InputCardNumber,
    InputSuit,
    InputName,
    InputUrl,
    InputDescription,
    InputHint,
    InputPlace,
    InputRadius,
    SearchLocation
  },
}
</script>

<style lang="scss" scoped>
</style>
